import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-project-settings',
    imports: [RouterOutlet],
    templateUrl: './project-settings.component.html',
    styleUrl: './project-settings.component.scss'
})

export class ProjectSettingsComponent {

}
